export default "__VITE_ASSET__Bg30w818__"